module.exports = __webpack_public_path__ + "static/img/newimg8.80c1336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg8.png
// module id = +o6S
// module chunks = 1